import { gql, TypedDocumentNode } from "@apollo/client";

import { Query } from "types/generated";
import { PickInner } from "types/helpers";

type AiSettingsData = Pick<
  Query,
  | "spaceliftIntelligenceTermsAccepted"
  | "spaceliftIntelligenceEnabled"
  | "infraAssistantEnabled"
  | "infraAssistantBuildModeEnabled"
> & {
  spaceliftIntelligenceTermsLatestVersion: PickInner<
    Query["spaceliftIntelligenceTermsLatestVersion"],
    "content" | "version"
  >;
};

export const GET_AI_SETTINGS: TypedDocumentNode<AiSettingsData> = gql`
  query GetAISettings {
    spaceliftIntelligenceTermsAccepted
    spaceliftIntelligenceEnabled
    spaceliftIntelligenceTermsLatestVersion {
      content
      version
    }
    infraAssistantEnabled
    infraAssistantBuildModeEnabled
  }
`;
